export default __webpack_public_path__ + "static/media/like.37dd0779.png";